'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _underscore = require('../../utils/underscore');

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _OptionTypes = require('../../types/OptionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UITypeaheadResultsGroup = function (_React$Component) {
  _inherits(UITypeaheadResultsGroup, _React$Component);

  function UITypeaheadResultsGroup() {
    _classCallCheck(this, UITypeaheadResultsGroup);

    return _possibleConstructorReturn(this, (UITypeaheadResultsGroup.__proto__ || Object.getPrototypeOf(UITypeaheadResultsGroup)).apply(this, arguments));
  }

  _createClass(UITypeaheadResultsGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          group = _props.group;

      this._id = this._id || (0, _underscore.uniqueId)('typeahead-results-group-');

      var computedClassName = (0, _classNames2.default)('small-caps', 'truncate-text', 'private-typeahead-results-group__label', group.dropdownClassName);

      var computedLabel = group.text || String(group.value);

      return _react2.default.createElement(
        'li',
        { className: 'private-typeahead-results-group', role: 'presentation' },
        _react2.default.createElement(
          'div',
          {
            'aria-hidden': true,
            className: computedClassName,
            id: this._id,
            title: group.title || computedLabel
          },
          group.icon ? _react2.default.createElement(_UIIcon2.default, { name: group.icon }) : null,
          ' ',
          computedLabel
        ),
        _react2.default.createElement(
          'ul',
          {
            'aria-labelledby': this._id,
            className: 'private-typeahead-results-group__list list-unstyled',
            role: 'listbox'
          },
          children
        )
      );
    }
  }]);

  return UITypeaheadResultsGroup;
}(_react2.default.Component);

exports.default = UITypeaheadResultsGroup;


UITypeaheadResultsGroup.propTypes = {
  children: _react.PropTypes.node,
  group: _OptionTypes.OptionGroupType.isRequired
};

UITypeaheadResultsGroup.displayName = 'UITypeaheadResultsGroup';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/typeahead/results/UITypeaheadResultsGroup.js
// module id = 681
// module chunks = 3 4